import { configureStore } from '@reduxjs/toolkit';

import rootReducer from '../reducers/reducers.js';
import { analytics } from '../middlewares/analytics';
import { initialState } from './initial-state';
import process from 'process';

const middlewares = [analytics];

export const getStore = (state = {}) => {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState: { ...initialState, ...state },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    // the candidate/reference form flows keep raw File objects for
                    // uploads in these paths only
                    ignoredPaths: [/^forms\.candidate\.filesUploaded/],
                    ignoredActionPaths: [/^payload\.file$/, /^meta\.arg\.answers/],
                },
            }).concat(middlewares),
        devTools: process.env.NODE_ENV !== 'production',
    });

    return { store };
};
